module.exports = __webpack_public_path__ + "static/10-33a2e4c07794ed1da2812ef90002260e.jpg";